import Competence from './Competence.vue';

export default Competence;



// WEBPACK FOOTER //
// ./src/pages/professions/card/competence/index.ts